import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, EventEmitter, ViewChild } from "@angular/core";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";

import {
  Aguas,
  CargosDetalles,
  CargosDetallesInput,
  AguaBloqueos,
  FBuscaProrrateos,
  EstadoCuentaInformacionInput,
  RAguasPersonas,
  ObtenerUsuarioPorCargoInput,
  Personas,
  CatProrrateo,
  PadObservaciones
} from "../../entidades/entidades";
import { Observable, empty } from "rxjs";

import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { AguasService } from "../../servicios/aguas.service";
import { PersonasService } from "../../servicios/personas.service";
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
import { FBuscaProrrateosService } from "../../servicios/f-busca-prorrateos.service";
import { CatProrrateoService } from "../../servicios/cat-prorrateo.service";
import { PadObservacionesService } from 'app/servicios/pad-observaciones.service';


@Component({
  selector: "app-prorrateos-grid",
  templateUrl: "./prorrateos-component.html",
  styleUrls: ["./prorrateos-component.css"],
  //providers: [MessageService],
})

export class ProrrateosComponent implements OnInit {
    muestraMensaje = new MuestraMensaje();
    public aguas$: Observable<Aguas>;
    public aguasLimpio: Aguas;
    public idAguasProceso: number;
  
    public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
    public cargosDetallesInputLimpio: CargosDetallesInput;
    public cargosDetalles: CargosDetalles;
    displayDialog: boolean = false;
    userInput: any = '' ;
    public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();
    public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
    catprorrateo: SelectItem[];
    public usuario: any;
    public rAguasPersonas: RAguasPersonas;
    public personas$: Observable<Personas>;
    public edoCuentaInformacion: EstadoCuentaInformacionInput;
    _id_agua: number;
    _cuenta_agua_general: number;
    public progressBar = false ;
    itemsMenu: MenuItem[];
    usuariosSelec: SelectItem[];
    public usuarios: ObtenerUsuarioPorCargoInput;
    columnasTabla: any[];
    fBuscaProrrateoArrays: FBuscaProrrateos[] = [];
    observacion: string;
    eliminaProp: boolean = false;
  
    constructor(
      private aguasService: AguasService,
      private rAguasPersonasService: RAguasPersonasService,
      private personasService: PersonasService,
      private catUsuariosService: ObtenerUsuarioPorCargoService,
      private authenticationService: AuthenticationService,
      private padObservacionesService: PadObservacionesService,
      private fBuscaProrrateosService: FBuscaProrrateosService,
      private catprorrateoService: CatProrrateoService,
    ) { }
  
    async ngOnInit() {
  
      
      await this.authenticationService.getUserByToken();
      this.usuario = this.authenticationService.currentUserValue;
      await this.getCatUsuarios();

          // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
        {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(),  },
        {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.validaElminacion();} },
        {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getFBuscaProrrateos(this._id_agua);} },
      ];
  
      // ===============================================================
      //Opciones de la tabla
      // ===============================================================
      // prettier-ignore
      this.columnasTabla = [
        {field: "operacion",header: "", ordenar: false, styleHeader: "width: 80px;"},
        {field: "cuentaAgua", header: "Cuenta Agua",ordenar: true, styleHeader: "width: 80px;",},
        {field: "derivada", header: "Padre",ordenar: true, styleHeader: "width: 80px;",},
        {field: "idProatero", header: "Tipo Prorrateo",ordenar: true, styleHeader: "width: 150px;",},
        {field: "titular", header: "Titular",ordenar: true, styleHeader: "width: 350px;",},
        {field: "calle", header: "Calle",ordenar: true, styleHeader: "width: 300px;",},
        {field: "colonia", header: "Colonia",ordenar: true, styleHeader: "width: 300px;",},
        {field: "numExterior", header: "Núm Ext.",ordenar: true, styleHeader: "width: 150px;",},
        {field: "numIneritr", header: "Núm. Int.",ordenar: true, styleHeader: "width: 150px;",},
        {field: "ruta", header: "Ruta",ordenar: true, styleHeader: "width: 80px;",},
        {field: "consecutico", header: "Consecutivo",ordenar: true, styleHeader: "width: 80px;",},
        {field: "uso", header: "Uso",ordenar: true, styleHeader: "width: 200px;",},
        {field: "estatus", header: "Estatus",ordenar: true, styleHeader: "width: 80px;",},
        {field: "medidor", header: "Medidor",ordenar: true, styleHeader: "width: 90px;",},
      ];

      await this.getAllCatConceptos();
      
    }

    // prettier-ignore
  async getAllCatConceptos() {
    try {
      const datoRetorno = await this.catprorrateoService.getAll().toPromise();
      
      this.catprorrateo = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatConceptos");
    }
  }

  async guardaObservacion() 
  {
    try {
          if (this.userInput.length > 0) 
           {  
               // guardamos observacion
               let aux = new PadObservaciones();
               aux.idAgua = this._id_agua;
               aux.observacion = this.userInput;  
               await this.padObservacionesService.add(aux).toPromise();
               this.userInput = '';
               await this.guardarGridFBuscaProrrateos(); 
               this.displayDialog = false;
           }
           else 
               throw new Error("Agregue una observacion para continuar.");
 
        
       
     this.eliminaProp = false;    
     } catch (e) {
       this.muestraMensaje.error(e.message, "top", "center");
       this.progressBar = false;
     } finally {
       console.log("Paso por guardaObservacion");
       this.progressBar = false; 
     }
  }

  async validaElminacion() {
    try { 
      //checamos si se elimino uno
      if (this.eliminaProp) 
        this.displayDialog = true; 
      else
        await this.guardarGridFBuscaProrrateos(); 
 

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      this.progressBar = false;
    } finally {
      console.log("Paso por validaElminacion");
      this.progressBar = false; 
    }
  }

  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridFBuscaProrrateos() {
    try {
      this.progressBar = true;
      await this.fBuscaProrrateosService.update(this.fBuscaProrrateoArrays).toPromise();

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
      await this.getFBuscaProrrateos(this._id_agua);

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      this.progressBar = false;
    } finally {
      console.log("Paso por guardarFBuscaProrrateos");
      this.progressBar = false; 
      this.eliminaProp = false;    
    }
  }

    //===============================================================
    //Agrega renglon en el grid
    //===============================================================
    // prettier-ignore
    add() {
        let fBuscaProrrateosNew = new FBuscaProrrateos();
        fBuscaProrrateosNew.cambio = true;
        fBuscaProrrateosNew.id = 0;
        fBuscaProrrateosNew.cuentaAgua = 0;
        fBuscaProrrateosNew.derivada = 0;
        fBuscaProrrateosNew.idProatero = this.catprorrateo[0]?.value;
        fBuscaProrrateosNew.cuentaGeneral = this._cuenta_agua_general;
        fBuscaProrrateosNew.numRow = this.fBuscaProrrateoArrays.length + 1;
        this.fBuscaProrrateoArrays.unshift(fBuscaProrrateosNew);
    }

     //===============================================================
    //Funciones de la tabla
    //===============================================================
    // prettier-ignore
    onEditInit(event) {
      event.cambio = true;
    }

    // prettier-ignore
    onEditCancel(event) {
      event.cambio = true;
    }

    // prettier-ignore
    async onDelete(event, index: number) {
        event.cambio = false;
        event.baja = true;
        this.eliminaProp = true;
    }

    // prettier-ignore
    async onEditComplete(event) {
      event.cambio = true;
    }

    obtenerDescripcion(id: number): string {
      if (!this.catprorrateo) return;
      const estatus = this.catprorrateo.find((a) => a.value === id);
      return estatus ? estatus.label : "";
    }
  
  
    // =====================================================
    //Carga principal
    // =====================================================
    async childAguaBuscaCuentas(idAgua: number) {
      try {
        this.fBuscaProrrateoArrays = [];
        this.progressBar = true;
        this.idAguasProceso = idAgua;

  
        this.limpiaInput();
        if (!this.idAguasProceso) {
          this.aguas$ = await this.aguasService.getSingle(0);
          this.personas$ = await this.personasService.getSingle(0);
  
          this.limpiaInput();
          return;
        }
  
        // carga formulario de agua
        this.aguas$ = await this.aguasService.getSingle(idAgua);


  
        //Carga formulario de personas
        const rAguasPersonasBusquedas = new RAguasPersonas();
        rAguasPersonasBusquedas.idAgua = idAgua;
        await this.getRAguasPersonas(rAguasPersonasBusquedas);
        this.personas$ = await this.personasService.getSingle(
          this.rAguasPersonas.idPersona
        );
  
        //Carga formulario estado-cuentas
        this.edoCuentaInformacion = new EstadoCuentaInformacionInput();
        this.edoCuentaInformacion.idAgua = idAgua;
        //this.edoCuentaInformacion.cuentaAgua = aguas.cuentaAgua;
        
        let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
        estadoCuentaInformacionInput.idAgua = idAgua;
        //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
        await this.estadoCuentaInformacionInput$.emit(
          estadoCuentaInformacionInput
        );
  
       this._id_agua = idAgua;
       await this.getFBuscaProrrateos(this._id_agua);

      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
        this.progressBar = false;
      } finally {
        console.log("Paso por childAguas");
        this.progressBar = false;
      }
    }

    async getFBuscaProrrateos(cuenta){
        try {    
          this.progressBar = true;
            ///////Consultamos 
            let aux = { cuentaAgua: cuenta }; 
            const datoRetorno = await this.fBuscaProrrateosService
            .getBusquedas(aux)
            .toPromise();
            
            this.fBuscaProrrateoArrays = datoRetorno;

            if(Object.keys(datoRetorno).length > 0) {
              this._cuenta_agua_general = datoRetorno.find(x => x.id == cuenta)?.cuentaAgua;
              var cuentaBuscada = datoRetorno.find(x => x.id == cuenta); 
              if(cuentaBuscada?.derivada === 0 && Object.keys(datoRetorno).length > 1)
                this.observacion = "Es un contrato padre"
              else if(cuentaBuscada?.derivada === 0 && Object.keys(datoRetorno).length===1)
                this.observacion = "Es un contrato normal"
              else 
                this.observacion = "Es un contrato hijo, el contrato padre es: "+datoRetorno[0].derivada ;
            }
              

        } catch (e) {
          this.progressBar = false;
          this.muestraMensaje.error(e.message, "top", "center");
          } finally {
            console.log("Paso por getFBuscaProrrateos");
            this.progressBar = false;
          }

    }

  
    async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
      try {
        const datoRetorno = await this.rAguasPersonasService
          .getBusquedas(rAguasPersonas)
          .toPromise();
        this.rAguasPersonas = datoRetorno[0];
      } catch (e) {
        if (e.response) {
          throw { message: e.response.data };
        } else {
          throw e;
        }
      } finally {
        console.log("Paso por getRAguasPersonas");
      }
    }
  
  
    async getCatUsuarios() {
      try {
        this.usuarios = new ObtenerUsuarioPorCargoInput();
  
        this.usuarios.idCargo = null;
        this.usuarios.idEstatus = null;
  
        let datoRetorno = await this.catUsuariosService
          .getBusquedas(this.usuarios)
          .toPromise();
        let usuarios = datoRetorno.filter(x=>x.id == this.usuario.id);
  
        this.usuariosSelec = usuarios.map((datos) => {
          return { label: datos.nombre, value: datos.id };
        });
        
        
        
        //this.usuariosSelec.unshift({ label: this.usuario.nombre, value: this.usuario.id });
  
  
        //SE ASIGNA EL USUARIO AL COMBO DE CAJEROS
      } catch (e) {
        if (e.response) throw { message: e.response.data };
        else throw e;
      } finally {
        console.log("Paso por getCatUsuarios");
      }
    }
  
    limpiaInput() {
      this.estadoCuentaInformacionInput$.emit(null);
      this.cargosDetallesInput$.emit(null);
    }
  }